import { Routes } from '@all-hands-hq/plex-graphql-schema';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useGetLoggedInUserQuery } from '../../graphql/queries/GetLoggedInUser';
import { logAnalytics } from './shared/logAnalytics';

export function PaywallAlert(): React.ReactElement {
  const { data, loading, error } = useGetLoggedInUserQuery({ variables: {} });
  const history = useHistory();

  const open =
    (history.location.pathname !== Routes.BILLING_SETTINGS_PATH &&
      !loading &&
      !error &&
      !data?.currentUser?.domain?.isBillingCurrent) ||
    false;

  useEffect(() => {
    if (open) logAnalytics({ name: 'hit paywall' });
  }, [open]);

  const handleUpdate = (): void => {
    history.push(Routes.BILLING_SETTINGS_PATH);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="paywall-dialog-title"
      aria-describedby="paywall-dialog-description"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogTitle id="paywall-dialog-title">Your Plex free trial is now over</DialogTitle>
      <DialogContent>
        <DialogContentText id="paywall-dialog-description">
          Thank you for using Plex. Your free trial is now over. Please click the button below to update your payment
          method to continue using our service.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUpdate} color="primary">
          UPDATE BILLING
        </Button>
      </DialogActions>
    </Dialog>
  );
}
